// src/components/Footer.jsx
export default function Footer() {
    return (
      <footer className="bg-dark text-white mt-5 py-4">
        <div className="container text-center">
          <p className="mb-0">&copy; 2023 MotherCare Clinic. All rights reserved.</p>
          <p className="mb-0">24/7 Helpline: +260-977-000-000</p>
        </div>
      </footer>
    );
  }